import axios from "axios";
import { API_BASE_URL } from "@/lib/apiBase";

export async function listSavedPosts(
  token,
  orgId,
  { limit = 20, offset = 0 } = {}
) {
  const { data } = await axios.get(`${API_BASE_URL}/saved-posts`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { org_id: orgId, limit, offset },
  });
  return data || { posts: [], total: 0 };
}

export async function getSavedPostsStatus(token, orgId, postIds = []) {
  const ids = [...new Set((postIds || []).map(String).filter(Boolean))];
  if (!ids.length) return { saved: {} };
  const { data } = await axios.get(`${API_BASE_URL}/saved-posts/status`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { org_id: orgId, post_ids: ids.join(",") },
  });
  return data || { saved: {} };
}

export async function savePost(token, orgId, postId) {
  const { data } = await axios.put(
    `${API_BASE_URL}/saved-posts/${postId}`,
    null,
    {
      headers: { Authorization: `Bearer ${token}` },
      params: { org_id: orgId },
    }
  );
  return data;
}

export async function unsavePost(token, orgId, postId) {
  const { data } = await axios.delete(
    `${API_BASE_URL}/saved-posts/${postId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params: { org_id: orgId },
    }
  );
  return data;
}
